import { useSyncExternalStore } from "react";
import { getTheme, subscribe, type Theme } from "@/stores/theme";

/** React hook that returns the current theme and re-renders on change. */
export function useTheme(): Theme {
  return useSyncExternalStore(subscribe, getTheme, getTheme);
}
